<template>
    <div class="hiq-search-app__result">
        <ul class="hiq-search-app__result--list" :aria-label="translations.searchResult">
            <result-item v-for="item in items" :key="item.id" :item="item"></result-item>
        </ul>
    </div>
</template>

<script>
import ResultItem from '../components/ResultItem.vue';
export default {
    name: 'search-result',
    computed: {
        items() {
            return this.$store.state.searchResult.items;
        },
        translations() {
            return this.$store.state.translations;
        }
    },
    components: {
        ResultItem
    }
}
</script>